<template>
    <div class="faq nunito">
        <h1>Preguntas Frecuentes</h1>
        <div class="content">
            <details v-for="faq in faqs" :key="faq.id">
                <summary>{{ faq.question }}</summary>
                <p>{{ faq.answer }}</p>
            </details>
        </div>
    </div>
</template>

<script>
import faqsData from "@/data/faqs.json";

export default {
    name: "FaqsPage",
    data() {
        return {
            faqs: faqsData, 
        };
    },
};
</script>

<style lang="scss" scoped>
.faq {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    line-height: 1.6;

    h1 {
        text-align: center;
        margin-bottom: 20px;
        font-size: 2.5rem;
    }

    .content {
        details {
            margin-bottom: 20px;

            summary {
                font-size: 1.25rem;
                font-weight: bold;
                cursor: pointer;
                list-style: none;
                margin-bottom: 10px;
            }

            p {
                font-size: 1rem;
                margin-left: 20px;
                margin-top: 10px;
            }
        }
    }
}
</style>


<style lang="scss" scoped>
body.dark-theme .faq {
    h1 {
        color:white;
    }
    .content {
        color:white;
            details {
                summary {
                    color:rgb(255, 255, 255);
                }

                p {
                    color:rgb(207, 201, 201);
                }
            }
        }
}
    .faq {
        max-width: 800px;
        margin: 0 auto;
        padding: 20px;
        line-height: 1.6;

        h1 {
            text-align: center;
            margin-bottom: 20px;
            font-size: 2.5rem;
        }

        .content {
            details {
                margin-bottom: 20px;

                summary {
                    font-size: 1.25rem;
                    font-weight: bold;
                    cursor: pointer;
                    list-style: none;
                    margin-bottom: 10px;
                }

                p {
                    font-size: 1rem;
                    margin-left: 20px;
                    margin-top: 10px;
                }
            }
        }
    }
</style>